<template>
  <div class="pageWrapper_home">
    <div class="fan_massage">
      <div class="top_header">
        <div class="back-icon" @click="goBack()">
          <i class="material-icons">arrow_back</i>
        </div>
        <div class="container">
          <Header update_profile_txt=" Update Your Profile" icon_txt="arrow_forward" />

          <div class="title_fanPage">
            <h1>{{$t('fanMessage')}}</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="middlePannel_fanPage">
        <div class="fan-mesagebox">
          <div class="fanimg-user">
            <img
              :src="this.requestDetail.user_profile_pic"
              v-if="this.requestDetail.user_profile_pic"
            />
            <img src="../assets/images/user_images.png" v-else />
          </div>
          <div class="info-blk">
            <h2>{{$t('requestedPerson')}}</h2>
            <p>{{this.requestDetail.request_from}}</p>
          </div>

          <div class="info-blk">
            <h2>{{$t('messageFor')}}</h2>
            <p>{{this.requestDetail.request_for}}</p>
          </div>

          <div class="info-blk">
            <h2>{{$t('message')}}</h2>
            <p>{{this.requestDetail.message}}</p>
          </div>

          <div class="info-blk">
            <h2>{{$t('requestdate')}}</h2>
            <p>{{this.requestDetail.time}}</p>
          </div>
        </div>
        <div class="btn-block">
          <Btn
            :btn_txt="$t('decline')"
            :btn_cls="isDisable ? 'dicline-btn disable' : 'dicline-btn' "
            v-if="!uploadBtn"
            @declineRequestCallback="declineRequest"
          />
          <Btn
            :btn_txt="$t('accept')"
            btn_cls="accept-btn"
            v-if="!uploadBtn"
            @acceptRequestCallback="acceptRequest"
          />
          <input
            type="file"
            id="fileInput"
            ref="myFiles"
            accept="video/*"
            @change="upload"
            class="custom-file-input"
            style="display:none;"
          />
          <input
            type="button"
            :value="$t('upload')"
            class="upload-btn"
            v-if="uploadBtn"
            onclick="document.getElementById('fileInput').click(); "
          />
        </div>

        <!-- ***popup start******** -->
        <div class="hover_bkgr_fricc">
          <span class="helper"></span>
          <div class="modal_popup">
            <vue-plyr ref="plyr">
              <video poster="poster.png" id="player" ref="previewContainer">
                <source ref="preview" type="video/mp4" size="1080" />
              </video>
            </vue-plyr>
            <Btn :btn_txt="$t('upload')" btn_cls="btn-success" @uploadVideo="confirm" />
            <Btn :btn_txt="$t('cancel')" btn_cls="btn-danger" @cancelVideo="cancel" />
          </div>
        </div>

        <!-- *****popup end******* -->
        <!-- popup for decline start -->
        <div class="hover_bkgr_fricc_decline">
          <span class="helper"></span>
          <div class="decline_popup">
            <!-- <div class="popupCloseButton" @click="closeModal()">x</div> -->
            <label for="RejectReason">Reject reason</label>
            <textarea
              rows="4"
              cols="50"
              name="comment"
              placeholder="Write comment here..."
              v-model="reasonCmnt"
            ></textarea>
            <Btn :btn_txt="$t('cancel')" btn_cls="skip-btn" @skipBtn="skipComment" />
            <Btn :btn_txt="$t('Submit')" btn_cls="submit-success" @submitBtn="submitComment" />
          </div>
        </div>

        <!-- popup for decline end -->
      </div>
    </div>
    <div class="loader" v-if="loading">
      <img src="../assets/images/gif-loader.gif" />
    </div>
    <!-- <Footer /> -->
  </div>
</template>

<script>
import Header from "../components/Header";
import Btn from "../components/Btn";
import Footer from "../components/Footer";
import axios from "axios";
import { getBase64Url, b64toBlob } from "../utils/helper";
import { FILE_UPLOAD_URL } from "../utils/constant";
import { toaster } from "../utils/helper";
import VueCookie from "vue-cookie";
export default {
  name: "FanDetails",
  components: {
    Footer,
    Btn,
    Header
  },
  data() {
    return {
      celebrity_id: "",
      pendingResponseList: [],
      uploadBtn: false,
      requestData: "",
      wall: "",
      video: "",
      on_request: "",
      image: "",
      media_link: "",
      file: null,
      loading: false,
      isDisable: false,
      videoBase64: "",
      reasonCmnt: "",
      requestDetail: {}
    };
  },
  props: {
    v_link: null
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async upload(file) {
      this.loading = !this.loading;
      this.file = this.$refs.myFiles.files[0];
      let base64 = await getBase64Url(this.$refs.myFiles.files[0]);
      this.$refs.previewContainer.src = base64;
      this.$refs.preview.src = base64;
      let blob = b64toBlob(base64, this.file.type);
      const formData = new FormData();
      formData.append("image", blob);
      formData.append("isResizeRequired", true);
      $(".hover_bkgr_fricc").show();
      this.loading = true;
      await axios
        .post(FILE_UPLOAD_URL, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(data => {
          this.loading = false;
          this.media_link =
            data.data.mediaVariantDTOs && data.data.mediaVariantDTOs[0].url;
        })
        .catch(err => {
          this.loading = !this.loading;
          toaster(
            this,
            "Something went wrong!! Please try again",
            "top-center",
            2000
          );
        });
    },
    confirm() {
      const obj = {
        media_link: this.media_link,
        request_id: this.$route.params.id,
        media_type: "on_request",
        media_ext: "video"
      };
      if (obj.media_link) {
        this.loading = !this.loading;
        this.$store
          .dispatch({ type: "uploadVideo", payload: obj })
          .then(data => {
            this.loading = !this.loading;
            toaster(this, "Your video is under process", "bottom-center", 3000);
            this.$router.go(-1);
          })
          .catch(err => {
            this.loading = !this.loading;
            toaster(
              this,
              "Something went wrong!! Please try again",
              "top-center",
              2000
            );
          });
      } else {
        this.loading = !this.loading;
        toaster(
          this,
          "Something went wrong!! Please try again",
          "top-center",
          2000
        );
      }
    },
    cancel() {
      document.getElementById("fileInput").value = null;
      $(".hover_bkgr_fricc").hide();
    },
    acceptRequest() {
      this.isDisable = true;
      this.uploadBtn = true;
      const obj = {
        request_id: this.$route.params.id,
        accepted_rejected: 1
      };
      this.loading = true;
      this.$store
        .dispatch({ type: "acceptReject", payload: obj })
        .then(data => {
          toaster(this, "Request accepted", "top-center", 2000);
          this.loading = false;
        })
        .catch(err => {
          this.loading = !this.loading;
          toaster(
            this,
            "Something went wrong!! Please try again",
            "top-center",
            2000
          );
        });
    },
    declineRequest() {
      $(".hover_bkgr_fricc_decline").show();
    },
    closeModal() {
      $(".hover_bkgr_fricc_decline").hide();
    },
    skipComment() {
      $(".hover_bkgr_fricc_decline").hide();

      // this.isDisable = true;
      // const obj = {
      //   request_id: this.$route.params.id,
      //   accepted_rejected: 0,
      //   message: this.reasonCmnt
      // };
      // this.loading=true;
      // this.$store
      //   .dispatch({ type: "acceptReject", payload: obj })
      //   .then(data => {
      //     this.loading=false;
      //     this.isDisable = true;
      //     toaster(this, "Request declined", "top-center", 3000);
      //     this.$router.go(-1);
      //   })
      //   .catch(err => {
      //     this.loading = !this.loading;
      //     this.isDisable = false;
      //     toaster(
      //       this,
      //       "Something went wrong!! Please try again",
      //       "top-center",
      //       2000
      //     );
      //   });
    },

    submitComment() {
      if (!this.reasonCmnt) {
        toaster(this, "Please Enter Comment", "top-center", 3000);
        return;
      } else {
        this.isDisable = true;
        const obj = {
          request_id: this.$route.params.id,
          accepted_rejected: 0,
          message: this.reasonCmnt
        };
        this.loading = true;
        this.$store
          .dispatch({ type: "acceptReject", payload: obj })
          .then(data => {
            this.loading = false;
            this.isDisable = true;
            toaster(this, "Request declined", "top-center", 3000);
            this.$router.go(-1);
          })
          .catch(err => {
            this.loading = !this.loading;
            this.isDisable = false;
            toaster(
              this,
              "Something went wrong!! Please try again",
              "top-center",
              2000
            );
          });
      }
    }
  },
  created() {
    this.requestDetail = JSON.parse(sessionStorage.getItem("request_detail"));
  },
  mounted() {
    if (this.$route.query.uploadBtn) this.uploadBtn = true;
  }
};
</script>
<style>
.decline_popup textarea {
  border: 1px solid #210031;
  width: 100%;
  font-size: initial;
  margin-bottom: 10px;
}
.hover_bkgr_fricc {
  background: rgba(0, 0, 0, 0.4);
  cursor: pointer;
  display: none;
  height: 100%;
  position: fixed;
  text-align: center;
  top: 0;
  width: 100%;
  z-index: 1;
  left: 0;
}

.hover_bkgr_fricc .helper {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
.hover_bkgr_fricc > div {
  background-color: #fff;
  box-shadow: 10px 10px 60px #555;
  display: inline-block;
  height: auto;
  max-width: 551px;
  min-height: 100px;
  vertical-align: middle;
  width: 90%;
  position: relative;
  border-radius: 8px;
  padding: 10px;
}
.hover_bkgr_fricc_decline {
  background: rgba(0, 0, 0, 0.4);
  cursor: pointer;
  display: none;
  height: 100%;
  position: fixed;
  text-align: center;
  top: 0;
  width: 100%;
  z-index: 1;
  left: 0;
}

.hover_bkgr_fricc_decline .helper {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
.hover_bkgr_fricc_decline > div {
  background-color: #fff;
  box-shadow: 10px 10px 60px #555;
  display: inline-block;
  height: auto;
  max-width: 551px;
  min-height: 140px;
  vertical-align: middle;
  width: 90%;
  position: relative;
  border-radius: 8px;
  padding: 10px;
}
.btn-success {
  background: #cb00e2;
  padding: 10px;
  width: 46%;
  color: #fff;
  font-weight: 700;
  position: relative;
  left: -22px;
  margin: 4px;
}
.submit-success {
  background: #cb00e2;
  padding: 8px;
  width: 46%;
  color: #fff;
  font-weight: 700;
  border: none;
  margin-left: 24px;
}
.skip-btn {
  background: #cb00e2;
  padding: 8px;
  width: 46%;
  color: #fff;
  font-weight: 700;
  border: none;
}

.btn-danger {
  background: #cb00e2;
  padding: 10px;
  color: #fff;
  font-weight: 700;
  width: 46%;
  position: relative;
  right: -18px;
}

.modal_popup video {
  width: 300px;
  height: 240px;
}
.popupCloseButton {
  background-color: #fff;
  border: 3px solid #999;
  border-radius: 50px;
  cursor: pointer;
  display: inline-block;
  font-family: arial;
  font-weight: bold;
  position: absolute;
  top: -12px;
  right: -12px;
  font-size: 25px;
  line-height: 20px;
  width: 30px;
  height: 30px;
  text-align: center;
}

.popupCloseButton:hover {
  background-color: #ccc;
}
@media only screen and (max-width: 767px) {
  .modal_popup video {
    width: 220px;
    height: 180px;
  }
  .btn-danger {
    right: -8px;
  }
  .btn-success {
    left: -12px;
  }
}
</style>



